<template>
  <form-group :label="label" :input-id="idCalc" :errors="errorsCalc" :successes="successes">
    <div class="text-center">
      <div class="text-primary mb-2">{{ $t("global.already-have-bigcommerce") }}</div>
      <input
        type="checkbox"
        :checked="value"
        :id="idCalc"
        :name="name"
        class="d-none"
        @click="onclick"
      />
      <label class="bigcommerce-toggle text-uppercase" :for="idCalc">
        <span class="ml-1" :class="{ selected: !value }">{{ $t("global.no") }}</span>
        <span class="mr-1" :class="{ selected: value }">{{ $t("global.yes") }}</span>
      </label>
    </div>
  </form-group>
</template>

<script>
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormBigCommerceAccountToggle",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  props: {
    value: Boolean,
  },
  setup(props, { emit }) {
    // should emit a boolean
    const onclick = (e) => {
      const checked = e.target.checked;
      emit("input", checked);
    };

    return { onclick };
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables";

.bigcommerce-toggle {
  border-radius: 12px;
  border-style: solid;
  border-width: 1px;
  padding: 4px 0px 4px 0px;
  cursor: pointer;

  span {
    padding: 2px 15px 2px 15px;
    border-radius: 12px;
  }
}
</style>
